import { Suspense, useEffect, useState } from "react";
import SickLeaveCard from "./SickLeaveCard";
import CertificateModal from "./CertificateModal";
import {
  ServicesAmount,
  SlamaRequestTypes } from
"../../utils/constants";

import ViewPayment from "./../common/ViewPayment";

import {
  getSickLeavePaymentUrl } from
"../../services/payment/payment";
import {
  getPatientCertificates,
  getPatientCertificatesUrl } from
"../../services/liferay/sickleave";

import PaymentModal from "./PaymentModal";
import {
  configureFirstIframe,
  getLayoutDirection, getPaymentStatusStatus,
  isAndroid,
  isArabic,
  isMobileApp,
  isMobileBrowser,
  openPdfToUrl,
  reloadOnBrowserBack } from
"../../utils/util";

import { fetchTranslationData } from "../../services/translation/translation";
import { ServiceTranslation } from "../../utils/constants";
import Warning from "../common/Warning";
import { Loader } from "../../common/Loader";
import WarningInfo from "../../common/WarningInfo";
import DirhamSymbol from "../../common/DirhamSymbol";

const SickLeave = () => {
  const [patientCertificates, setPatientCertificates] = useState([]);
  const [modalContent, setModalContent] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [sickLeavePaymentId, setSickLeavePaymentId] = useState(null);
  const [translationMap, setTranslationMap] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [showInitatedPopUp, setShowInitatedPopUp] = useState(false);
  const [exceptionError, setExceptionError] = useState(false);
  const [errorHeading, setErrorHeading] = useState("");
  const [errorSubHeading, setErrorSubHeading] = useState("");
  const [indexValue, setIndexValue] = useState();
  const [status, setStatus] = useState("");

  useEffect(() => {
    // status change mobile
    // configureFirstIframe(2000, 1300, false);
    window.parent.scrollTo(0, 0);
    fetchTranslationData(ServiceTranslation.SickLeave).then((result) => {
      setTranslationMap(result);
    });
    getPatientCertificates().then((result) => {
      setPatientCertificates(result.data);
      if (result.data.length > 0) {
        let length;
        if (isMobileBrowser()) {
          length = 460 + 340 * result.data.length;
        } else {
          length = 170 + 170 * result.data.length;
        }
        configureFirstIframe(200, length, true);
        result.data.forEach((item) => {
          if (item?.sickLeaveStatus?.toUpperCase() === "INITIATED") {
            setShowInitatedPopUp(true);
          }
        });
      } else {
        configureFirstIframe(200, -650);
      }
      setIsLoading(false);
    }).catch((error) => {
      setIsLoading(false);
      setExceptionError(false);
      setErrorHeading(translationMap?.somethingWentWrongMesg ?? "Something went wrong. Please try again later.");
      setErrorSubHeading("");

    });
    setIsMobile(isMobileApp());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // handing the reload on browser back start
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    setStatus(await getPaymentStatusStatus(SlamaRequestTypes.sickLeaveApplication));
    reloadOnBrowserBack();
  }, []);

  async function handlePaymentSumbit(serviceId) {
    setExceptionError(false);
    setIsLoading(true);
    getSickLeavePaymentUrl(serviceId)
    .then((result) => {
      if (result.status === 200) {
        let url = result.data?.url;
        if (url) {
          if (isMobile) {
            window.location.href = url;
          } else {
            window.parent.location.href = url;
          }
        } else {
          setShowPaymentModal(false);
        }
      } else {
        setIsLoading(false);
      }
    })
    .catch((error) => {
      const status = error.response?.status;
      const errorMsg = error.response?.data?.error;

      if (status === 400) {
        setExceptionError(true);
        setErrorHeading(translationMap?.checkSalama ?? "Check details on Salama");
        setErrorSubHeading(translationMap?.[errorMsg] ?? "please verify details");
      } else {
        setExceptionError(true);
        setErrorHeading(translationMap?.somethingWentWrongMesg ?? "Something went wrong. Please try again later.");
        setErrorSubHeading("");

      }

      setShowPaymentModal(false);
      setIsLoading(false);
    });
  }

  // let status = getItemWithExpiry("slaPaymentStatus");

  const handlePayment = (id) => {
    setSickLeavePaymentId(id);
    setShowPaymentModal(!showPaymentModal);
    window.parent.scrollTo(0, 0);
  };

  const handleViewCertificate = async (index, type, e) => {
    const patientDetail = patientCertificates[index];
    setIndexValue(index);

    if (type === "view") {
//      if (isMobile) {
//        const base64 = await getPatientCertificatesUrl(patientDetail.id);
//        let dataUrl = openPdfToUrl(base64.data);
//        window.open(dataUrl, "_parent");
//      } else {
        setModalContent(patientDetail);
        window.parent.scrollTo(0, 0);
        setShowModal(true);
//      }
    } else if (type === "download") {
      const button = e.target.closest(".button2");

      button.classList.add("active");
      const base64 = await getPatientCertificatesUrl(patientDetail.id);
      let dataUrl = openPdfToUrl(base64.data);

      if (isMobile) {
        if (isAndroid()) {
          window.open(dataUrl, "_parent");
        } else {
          const fileName = `SickLeaveCertificate_${patientDetail.id}.pdf`;
          if (navigator.canShare) {
            try {
              const binary = atob(base64.data);
              const bytes = new Uint8Array(binary.length);
              for (let i = 0; i < binary.length; i++) {
                bytes[i] = binary.charCodeAt(i);
              }
              const pdfFile = new File([bytes], fileName, { type: "application/pdf" });
              if (navigator.canShare({ files: [pdfFile] })) {
                await navigator.share({ files: [pdfFile], title: fileName });
              }
            } catch (shareError) {
            }
          }
        }
      }

      setTimeout(() => {
        button.classList.remove("active");
        button.querySelector("i").classList.replace("fa-download", "fa-check");
        button.querySelector("span").innerText = translationMap?.downloaded;
        button.classList.add("download1");

        if (!isMobile) {
          window.open(dataUrl, "_blank");
        }
      }, 6000);
    }
  };

  const closeModal = () => {
    window.parent.scrollTo(0, 0);
    setShowModal(false);
  };

  const closePaymentModal = () => {
    setShowPaymentModal(false);
  };

  if (isLoading) return <Loader />;

  return (
    <div
      className={` custombody_color ${getLayoutDirection()}`}
      id="sectionSickLeave">
      
            <section
        className="w-100 clearfix SickLeaveConfirmationSection"
        id="CoverPlanActive">
        
                <div className="container customContainer">
                    {!isMobile &&
          <div className="Title_Inner_Box">
                            <h6 className="MainTitleOne">
                                {translationMap?.sick_leave_certificate}
                            </h6>
                        </div>
          }
                    <div className="cover_inner_wrapper cover_inner_wrapper2">
                        <div className="cover_main_box1">
                            <div className="AlertMainWrapper">
                                <div className="AlertInnerBox BlueAlertInnerBox">
                                    <div className="Icon_box">
                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                        <a href="javascript:void(0);">
                                            <span className="material-symbols-outlined">help</span>
                                        </a>
                                    </div>
                                    <div className="alert_text">
                                        <p>
                                            <ul>
                                                <li style={{ listStyle: "disc", marginLeft: "8px" }}>
                                                    {translationMap?.infoBlueMessageOne}
                                                </li>
                                                <li style={{ listStyle: "disc", marginLeft: "8px" }}>
                                                    {isArabic() ?
                                                      <>{translationMap?.infoBlueMessageTwo}{" "}70<DirhamSymbol marginTop={-2} /></> :
                                                      <>{translationMap?.infoBlueMessageTwo}{" "}<DirhamSymbol marginTop={-2} />70</>
                                                    }
                                                </li>
                                            </ul>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {showInitatedPopUp &&
              <Warning
                desc={translationMap?.payment_waiting_message}
                heading={translationMap?.waitingPaymentConfirmation} />

              }
                            {patientCertificates && patientCertificates.length > 0 ?
              <>
                                    {status && status !== "" && status !== undefined ?
                status === "success" ?
                <>
                                                <div
                    className="AlertInnerBox GreenAlertInnerBox alert alert-dismissible fade show">
                                                    <button
                      type="button"
                      className="close"
                      data-dismiss="alert">
                      
                                                        <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        
                                                            <path
                          d="M17 7L7 17M7 7L17 17"
                          stroke="#002F70"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round" />
                        
                                                        </svg>
                                                    </button>
                                                    <div className="Icon_box">
                                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                                        <a href="javascript:void(0);">
                              <span className="material-symbols-outlined">
                                check_circle
                              </span>
                                                        </a>
                                                    </div>
                                                    <div className="alert_text">
                                                        <h6>
                                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                                            <a href="javascript:void(0);">
                                                                {
                          translationMap?.certificate_has_been_attested_successfully
                          }
                                                            </a>
                                                        </h6>
                                                        <p className="number_txt">
                                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                                            <a href="javascript:void(0);">
                                                                {translationMap?.payment_success_message}
                                                            </a>
                                                        </p>
                                                    </div>
                                                </div>
                                            </> :
                status === "cancelled" ?
                <>
                                                <div
                    className="AlertInnerBox YellowAlertInnerBox alert alert-dismissible fade show">
                                                    <button
                      type="button"
                      className="close"
                      data-dismiss="alert">
                      
                                                        <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        
                                                            <path
                          d="M17 7L7 17M7 7L17 17"
                          stroke="#002F70"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round" />
                        
                                                        </svg>
                                                    </button>
                                                    <div className="Icon_box">
                                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                                        <a href="javascript:void(0);">
                              <span className="material-symbols-outlined">
                                warning
                              </span>
                                                        </a>
                                                    </div>
                                                    <div className="alert_text">
                                                        <h6>
                                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                                            <a href="javascript:void(0);">
                                                                {
                          translationMap?.certificate_could_not_be_attested
                          }
                                                            </a>
                                                        </h6>
                                                        <p className="number_txt">
                                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                                            <a href="javascript:void(0);">
                                                                {translationMap?.payment_error_message}
                                                            </a>
                                                        </p>
                                                    </div>
                                                </div>
                                            </> :

                <>
                                                <div
                    className="AlertInnerBox YellowAlertInnerBox alert alert-dismissible fade show">
                                                    <button
                      type="button"
                      className="close"
                      data-dismiss="alert">
                      
                                                        <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        
                                                            <path
                          d="M17 7L7 17M7 7L17 17"
                          stroke="#002F70"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round" />
                        
                                                        </svg>
                                                    </button>
                                                    <div className="Icon_box">
                                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                                        <a href="javascript:void(0);">
                              <span className="material-symbols-outlined">
                                warning
                              </span>
                                                        </a>
                                                    </div>
                                                    <div className="alert_text">
                                                        <h6>
                                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                                            <a href="javascript:void(0);">
                                                                {
                          translationMap?.certificate_could_not_be_attested
                          }
                                                            </a>
                                                        </h6>
                                                        <p className="number_txt">
                                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                                            <a href="javascript:void(0);">
                                                                {translationMap?.payment_error_message}
                                                            </a>
                                                        </p>
                                                    </div>
                                                </div>
                                            </> :


                ""
                }

                                    {exceptionError &&
                <WarningInfo
                  setError={setExceptionError}
                  alert_text={
                  errorHeading
                  }
                  number_text={
                  errorSubHeading
                  } />

                }

                                    <div className="Result_Title_Box">
                                        <p className="Gray_Title">
                                            {translationMap?.showing} {patientCertificates.length}{" "}
                                            {translationMap?.results}
                                        </p>
                                    </div>

                                    {!isLoading &&
                patientCertificates &&
                patientCertificates.map((patient, index) =>
                <SickLeaveCard
                  key={index}
                  data={index}
                  doctorName={patient.doctorName}
                  toDate={patient.leaveEndDate}
                  fromDate={patient.leaveStartDate}
                  orderPlaceDate={patient.orderPlacedDateTime}
                  onViewCertificate={handleViewCertificate}
                  onPayment={() =>
                  handlePayment(patient.sickLeaveDetailId)
                  }
                  paymentStatus={
                  patient?.sickLeaveStatus ?
                  patient.sickLeaveStatus :
                  ""
                  }
                  translationMap={translationMap}
                  isMobile={isMobile} />

                )}
                                </> :

              <>
                                    <div
                  className="AlertInnerBox YellowAlertInnerBox alert alert-dismissible fade show">
                                        <div className="Icon_box">
                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                            <a href="javascript:void(0);">
                                                <span className="material-symbols-outlined">info</span>
                                            </a>
                                        </div>
                                        <div className="alert_text">
                                            <h6>
                                                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                                <a href="javascript:void(0);">
                                                    {translationMap?.no_sick_leave_certificates}
                                                </a>
                                            </h6>
                                            <p className="number_txt"></p>
                                        </div>
                                    </div>
                                </>
              }
                        </div>
                        <div className="cover_main_box2">
                            <ViewPayment
                to={`/payment-history/${SlamaRequestTypes.sickLeaveApplication}`}
                translationMap={translationMap} />
              
                        </div>
                    </div>
                </div>
            </section>

                {showModal &&
        <Suspense fallback={<div>Loading...</div>}>
                        <CertificateModal
            show={showModal}
            onClose={closeModal}
            content={modalContent}
            translationMap={translationMap}
            onViewCertificate={handleViewCertificate}
            data={indexValue}
            isMobile={isMobile} />

                    </Suspense>
        }

            {showPaymentModal && sickLeavePaymentId &&
      <Suspense fallback={<div>Loading...</div>}>
                    <PaymentModal
          show={showPaymentModal}
          close={closePaymentModal}
          handlePaymentSumbit={handlePaymentSumbit}
          headerText={translationMap?.attest_sick_leave_certificate}
          certificationFee={ServicesAmount.sickLeave}
          certificationFeeText={translationMap?.attest_sick_leave_fee}
          serviceId={sickLeavePaymentId}
          translationMap={translationMap} />
        
                </Suspense>
      }
        </div>);

};

export default SickLeave;